import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ability, { AbilityContext } from './ability';
import App from './App';
import store from './store';

ReactDOM.render(
    // <React.StrictMode>
    <AbilityContext.Provider value={ability}>
        <Provider store={store}>
            <App />
        </Provider>
    </AbilityContext.Provider>,
    // </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
